import Appsignal from "@appsignal/javascript";

export const appsignal = new Appsignal({
  key: `${process.env.REACT_APP_APPSIGNAL_KEY}`,
  revision: "e07cb89c4323ab55f04e1eed32f5742b9531f7a6",
});
